<template>
  <div>
    <v-row>
      <v-col>
        <v-card class="mb-3" elevation="0">
          <v-card-title class="portal-deep-blue-bg">
            Master Data
          </v-card-title>
          
          <v-card-text class="mt-5">
            <v-simple-table class="dp-gray" dense>
              <template v-slot:default>
                <thead></thead>
                <tbody>
                  <tr>
                    <th class="text-left shrink" colspan="2">Description</th>
                    <td colspan="2">{{ asset?.asset?.description }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">UIC number</th>
                    <td colspan="2">{{ asset?.asset?.uicnumber }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">Manufacturer</th>
                    <td colspan="2">{{ asset?.asset?.manufacturer }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">
                      Date of Manufacture
                    </th>
                    <td colspan="2">
                      {{ formatdate(asset?.asset?.manufacturerDate) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">Owner</th>
                    <td colspan="2">{{ asset?.asset?.owner }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="2">Operator</th>
                    <td colspan="2">{{ asset?.asset?.operator?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 1</th>
                    <td colspan="3">{{ asset?.asset?.ecm1?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 2</th>
                    <td colspan="3">{{ asset?.asset?.ecm2?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 3</th>
                    <td colspan="3">{{ asset?.asset?.ecm3?.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">ECM 4</th>
                    <td class="text-left" colspan="3">
                      {{ asset?.asset?.ecm4?.name }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left shrink" colspan="1">
                      {{ $t("message.infoloc.cert", { value: "default" }) }}
                    </th>
                    <td colspan="3">
                      <v-chip
                        class="mr-2 mt-2"
                        v-for="item in homologations"
                        :key="item.assetspedid"
                        @click="setRestrictionModal(item)"
                        outlined
                        label
                      >
                        <country :code="item.country" />
                        <span
                          v-if="countryRestriction(item) !== null"
                          :class="{
                            'state-partial': countryRestriction(item) === 'PARTIAL',
                            'state-full': countryRestriction(item) === 'FULL'
                          }"
                        />
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mb-6" elevation="0">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.infoloc.infoOp", { value: "default" }) }}
          </v-card-title>
          <v-card-text class="mt-5">
            <v-simple-table class="dp-gray" dense>
              <template v-slot:default>
                <thead>
                </thead>
                
                <tbody>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.softwareversion", { value: "default", }) }}
                    </th>
                    <td>{{ asset?.asset?.softwareversion }}</td>
                  </tr>
                  
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.engineeringvariant", { value: "default", }) }}
                    </th>
                    <td>{{ asset?.asset?.engineeringvariant }}</td>
                  </tr>
                  
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.page.status", { value: "default" }) }}
                    </th>
                    <td>{{ asset?.asset?.status }}</td>
                  </tr>
                  
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.magic.restriction", { value: "default" }) }}
                    </th>
                    <td>{{ remark }}</td>
                  </tr>
                  
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.page.locate", { value: "default" }) }}
                    </th>
                    <td>{{ workorder?.location }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.actWorkorder", { value: "default", }) }}
                    </th>
                    <td>{{ workorder?.description }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.outPrevDate", { value: "default", }) }}
                    </th>
                    <td>{{ formatdate(workorder?.schedfinish) }}</td>
                  </tr>
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.unitToGo", { value: "default" }) }}
                    </th>
                    <td>{{ pleft }}</td>
                  </tr>
                  
                  <tr>
                    <th class="text-left shrink">
                      {{ $t("message.infoloc.nextWorkDate", { value: "default", }) }}
                    </th>
                    <td>{{ formatdate(calcduedate) }}</td>
                  </tr>
                  
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="restrictionModal" scrollable width="500">
      <v-card class="restriction-modal">
        <h2>
          {{ $t('message.restriction.title') }}
          <country :code="restrictionData.country" class="country" />
        </h2>
        <div v-if="restrictionData.partial.length" class="restriction-block">
          <p class="partial-restriction-title">{{ $t('message.restriction.partial') }}</p>
          <div v-for="(rst, idx) in restrictionData.partial" class="restriction" :key="idx">
            <p class="description">{{ rst.description }}</p>
            <p class="dates">
              {{
                $t('message.restriction.dates', {
                  start: formatDate(rst.startDate),
                  end: rst.endDate ? formatDate(rst.endDate) : ''
                })
              }}
            </p>
          </div>
        </div>
        <div v-if="restrictionData.full.length" class="restriction-block">
          <p class="full-restriction-title">{{ $t('message.restriction.total') }}</p>
          <div v-for="(rst, idx) in restrictionData.full" class="restriction" :key="idx">
            <p class="description">{{ rst.description }}</p>
            <p class="dates">
              {{
                $t('message.restriction.dates', {
                  start: formatDate(rst.startDate),
                  end: rst.endDate ? formatDate(rst.endDate) : ''
                })
              }}
            </p>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { formatMagicDate } from "@/shared/DateHelper";
import Country from "@/components/country/Country.vue";

export default {
  components: {
    Country
  },
  props: ['asset', 'workorder', 'homologations', 'pleft', 'calcduedate', 'remark'],
  data () {
    return {
      restrictionModal: false,
      restrictionData: {
        full: [],
        partial: []
      },
    }
  },
  methods: {
    formatdate(date) {
      return formatMagicDate(date, this.$i18n.locale);
    },
    countryRestriction(operability) {
      if (!operability.restrictions) {
        return null;
      }
      const currentRst = operability.restrictions.filter(this.isRestrictionActive)
      if (currentRst.filter((rst) => rst.type === 'Full_restriction').length) {
        return 'FULL'
      }
      if (currentRst.filter((rst) => rst.type === 'Partial_restriction').length) {
        return 'PARTIAL'
      }
    },
    setRestrictionModal(operability) {
      if (!this.countryRestriction(operability)) {
        return;
      }
      this.restrictionModal = true;
      this.restrictionData = {
        full: [],
        partial: []
      }
      const currentRestrictions = operability.restrictions.filter(this.isRestrictionActive)
      this.restrictionData.full = currentRestrictions.filter(r => r.type === 'Full_restriction')
      this.restrictionData.partial = currentRestrictions.filter(r => r.type === 'Partial_restriction')
      this.restrictionData.country = operability.country
    },
    isRestrictionActive(r) {
      const date = new Date()
      return (
        new Date(r.startDate) <= date && (r.endDate == null || new Date(r.endDate) > date)
      )
    },
    formatDate(s) {
      const date = new Date(s)
      let day = date.getDate().toString()
      if (day.length === 1) {
        day = `0${day}`
      }
      let month = (date.getMonth() + 1).toString()
      if (month.length === 1) {
        month = `0${month}`
      }
      const year = date.getFullYear().toString().slice(-2)
      return `${day}/${month}/${year}`
    },
  }
}
</script>

<style scoped>
.restriction-pop-up-list {
  display: flex;
  flex-direction: column;
}

.dates {
  margin-top: 0.5em;
  font-weight: 550;
  color: darkgray;
  font-size: 12px;
  line-height: 12px;
}

.full-restriction-title {
  font-weight: bold;
  border-bottom: 2px solid red;
}

.partial-restriction-title {
  font-weight: bold;
  border-bottom: 2px solid orange;
}

.restriction-block {
  margin-block: 0.2em;
}

.restriction {
  margin-block: 0.2em;
}

.restriction + .restriction {
  margin-top: 0.5em;
  border-top: 1px dotted gray;
}

.description {
  font-weight: light;
  font-style: italic;
}

.restriction-modal {
  display: flex;
  flex-direction: column;
  padding: 2em;
}

.country {
  margin-left: 0.5em;
}

.state-full {
  height: 1em;
  width: 1em;
  background-color: red;
  margin-left: 0.5em;
  border-radius: 50%;
  display: inline-block;
}
.state-partial {
  height: 1em;
  width: 1em;
  background-color: orange;
  margin-left: 0.5em;
  border-radius: 50%;
  display: inline-block;
}
</style>